import { Grid } from '@atgfr8/atg-ui-tailwind';
import { useParams } from '@solidjs/router';
import { orderStore } from '@store/orders';
import {
  CustomerFileUpload,
  CustomerInformation,
  CustomerPayments,
  CustomerUploadFileProps,
  NewATGOnlyNote,
} from '@views/order/components';
import { Show } from 'solid-js';
import { CHANGE_TRACKING_SOURCES } from '@changeTracking/utils/changeTrackingRegistry';

export type CustomerProps = {
  customerFileUploadProps: CustomerUploadFileProps;
  lgBreakpoint: number;
};

export function Customer(props: CustomerProps) {
  const params = useParams();

  const isCreate = !params.id;

  return (
    <Grid item size={{ md: 12, lg: props.lgBreakpoint }}>
      <CustomerInformation />
      <Show when={!isCreate}>
        <CustomerFileUpload
          {...props.customerFileUploadProps}
          deleteChangeTrackingSource={
            CHANGE_TRACKING_SOURCES.orderDetails.documentsDelete
          }
          uploadChangeTrackingSource={
            CHANGE_TRACKING_SOURCES.orderDetails.documentsUpload
          }
        />
      </Show>
      {!isCreate && (
        <NewATGOnlyNote
          cardTitle="Internal Notes"
          type="Order"
          comments={orderStore.order.comments ?? []}
          loading={orderStore.loading}
          changeTrackingSource={
            CHANGE_TRACKING_SOURCES.orderDetails.internalNotes
          }
        />
      )}
      <Show when={!orderStore.isCreate}>
        <CustomerPayments />
      </Show>
    </Grid>
  );
}
